import { CdkDragDrop, copyArrayItem, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { User } from 'src/app/model';
import { UserService, LogService} from 'src/app/services';
import { FilterType } from '../../models/enums/filter.type';
import { IssueStage } from '../../models/enums/issue.stage';
import { ReportedIssue } from '../../models/reported-issue';
import { HttpService } from '../../services/http-service.service';




@Component({
  selector: 'app-mini-kanban',
  templateUrl: './mini-kanban.component.html',
  styleUrls: ['./mini-kanban.component.scss']
})
export class MiniKanbanComponent implements OnInit, OnDestroy {
  issues: ReportedIssue[] = [];
  toDo: ReportedIssue[] = [];
  inProgress: ReportedIssue[] = [];
  filterEnum = FilterType;
  activeFilter: FilterType = FilterType.All;

  currentUserSub: any;
  currentUser: User;
  constructor(private httpService: HttpService, private userService: UserService,private logService : LogService) { }

  ngOnInit(): void {
    this.getIssues();
    this.currentUserSub = this.userService.user$.subscribe(currentUser => {
      this.currentUser = currentUser;


    });
  }

  ngOnDestroy(): void {
    if (this.currentUserSub) this.currentUserSub.unsubscribe();
  }

  drop(event: CdkDragDrop<any[]>): void {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }
  }

  getIssues() {
    this.httpService.getReportedIssue()
      .subscribe(
        data => {
          if (data.success) {
            this.issues = ReportedIssue.parseArray(data.result.items);
            this.toDo = this.issues.filter(x => x.STAGE == IssueStage.TODO);
            this.inProgress = this.issues.filter(x => x.STAGE == IssueStage.IN_PROGRESS);
            this.logService.log(this.issues)
          }
        }, err => {
          this.logService.log(err);
        });

  }

  onChangeFilter(val: FilterType) {
    this.activeFilter = val;
    switch (val) {
      case FilterType.All:
        this.toDo = this.issues.filter(x => x.STAGE == IssueStage.TODO);
        this.inProgress = this.issues.filter(x => x.STAGE == IssueStage.IN_PROGRESS);
        break;
      case FilterType.My:
        var data = this.issues.filter(x => x.CREATED_BY?.ID == this.currentUser.ID)
        this.toDo = data.filter(x => x.STAGE == IssueStage.TODO);
        this.inProgress = data.filter(x => x.STAGE == IssueStage.IN_PROGRESS);
        break;
      case FilterType.None:
        this.toDo = [];
        this.inProgress = [];
        break;
    }

  }
}
